import React, { Component } from 'react'
import Link from 'gatsby-link'

import Home from '../components/home';
import Shelf from '../components/shelf';
import AppPrompt from '../components/app-prompt';
import CompanyInfo from '../components/company-info';
import Footer from '../components/footer';

/** Mock Images **/
import home from '../assets/images/home.png';
import tally from '../assets/images/tally.png';
import bill from '../assets/images/bill.png';


export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFooter:false
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const scrollTop = window.pageYOffset;
    if (scrollTop > window.innerHeight && !this.state.showFooter) {
      this.setState({
        showFooter: true
      });
    } else if (scrollTop < window.innerHeight && this.state.showFooter) {
      this.setState({
        showFooter: false
      });
    }
  }

  render() {
    return (
      <div id="app">
        <Home />
        <Shelf
          tagline="Follow Your Representatives"
          blurb="Keep up with how your elected officials are representing you in congress. Connect with your Representatives instantly."
          image={home}
        />
        <Shelf
          flip
          tagline="Stay Informed"
          blurb="Follow the legislation you care about and see how your Representatives, and everyone in Congress, is voting. Monitor campaign promises and hold elected officials accountable."
          image={tally}
          rotate="West"
        />
        <Shelf
          tagline="Directly From The Source"
          blurb="Get information on Bills, Nominations, Votes, & Campaign donations directly from the Federal Congressional Record and the Federal Election Commission."
          image={bill}
          rotate="East"
        />
        <CompanyInfo />
        {this.state.showFooter ? <AppPrompt/> : null}
        <Footer />
      </div>
  );
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js